
    export default {
        props: ['featured_images'],
        mounted() {}
    }
